import { connect } from "react-redux";

import actions from "../../actions";
import SchedulePanelOpcOsaka from "../../components/summary/SchedulePanelOpcOsaka";

const mapStateToProps = (state) => {
  const { scheduleSelectedCells, loadingPanel } = state.summary;

  return {
    scheduleSelectedCells,
    loadingPanel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createScheduleOpcOsaka: (params, callback) => dispatch(actions.summary.createScheduleOpcOsaka(params, callback)),
    endSelectSchedule: (callback) => dispatch(actions.summary.endSelectSchedule(callback)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePanelOpcOsaka);
